import { render, staticRenderFns } from "./OrderHistoryDialog.vue?vue&type=template&id=5bbae082&"
import script from "./OrderHistoryDialog.vue?vue&type=script&lang=js&"
export * from "./OrderHistoryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports